import { render, staticRenderFns } from "./teacherDetail.vue?vue&type=template&id=310ae6d2&scoped=true&"
import script from "./teacherDetail.vue?vue&type=script&lang=js&"
export * from "./teacherDetail.vue?vue&type=script&lang=js&"
import style0 from "./teacherDetail.vue?vue&type=style&index=0&id=310ae6d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310ae6d2",
  null
  
)

export default component.exports